import { useGetList } from 'react-admin';
import { MANAGER_PLACES, USERS } from '@/utils/CONST';
import { composeUri } from '@/utils/compose';

interface Props {
    userId: string;
}

const useGetManagerPlacesByUser = ({ userId }: Props) => {
    const {
        data,
        isLoading,
        // total,
        refetch: refetchAssigned,
    } = useGetList(
        MANAGER_PLACES,
        {
            sort: {
                field: 'creationDate',
                order: 'ASC',
            },
            filter: {
                userManager: composeUri(USERS, userId),
            },
        },
        { enabled: !!userId },
    );

    return { data, isLoading, refetchAssigned };
};

export default useGetManagerPlacesByUser;
